<app-upload [disabled]="showProgress" (uploadStatus)="uploadStatus($event)"></app-upload>
<p *ngIf="showProgress"> progress <strong>{{percentage}}%</strong></p>

<label class="error" [hidden]="!showDownloadError">دانلود فایل با مشکل مواجه شد</label>
<label class="error" [hidden]="!showUploadError">آپلود فایل با مشکل مواجه شد</label>

<div class="container" style="display: none;">
  <ul style="font-size: 10px;color: #3fb98e;">
    <li *ngFor="let file of files">
      <a>
        <small>{{file}}</small>
        <app-download [disabled]="showProgress" [fileName]="file.name" (downloadStatus)="downloadStatus($event)"></app-download>
      </a>
    </li>
  </ul>
</div>

